<!-- @format -->

<div class="modal-header">
  <h2>{{ "PROFILE.STUDY_RIGHT_DECISION_MODAL.TITLE" | translate }}</h2>
  <sis-modal-close-button />
</div>
<div class="modal-body">
  <sis-description-list [fillByColumn]="false">
    <dl>
      @if (isPassivation) {
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_RIGHT_STATE_TITLE" | translate }}</dt>
          <dd>{{ "PROFILE.STATE.PASSIVATED" | translate }}</dd>
        </ng-template>
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_RIGHT_PASSIVATION.PASSIVATION_TYPE.LABEL" | translate }}</dt>
          <dd>{{ "PROFILE.STUDY_RIGHT_PASSIVATION.PASSIVATION_TYPE." + passivation.passivationType | translate }}</dd>
        </ng-template>
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_RIGHT_DECISION_MODAL.VALID" | translate }}</dt>
          <dd>{{ passivation.valid | localDateRange }}</dd>
        </ng-template>
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_RIGHT_DECISION_MODAL.INFO" | translate }}</dt>
          <dd>{{ passivation.additionalInfo }}</dd>
        </ng-template>
      } @else {
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_RIGHT_STATE_TITLE" | translate }}</dt>
          <dd>{{ "PROFILE.STATE." + cancellation.cancellationType | translate }}</dd>
        </ng-template>
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_RIGHT_DECISION_MODAL.DATE" | translate }}</dt>
          <dd>{{ cancellation.cancellationDate | localDateFormat }}</dd>
        </ng-template>
        <ng-template #listItem>
          <dt class="sis-label">{{ "PROFILE.STUDY_RIGHT_DECISION_MODAL.INFO" | translate }}</dt>
          <dd>{{ cancellation.cancellationReason }}</dd>
        </ng-template>
      }
    </dl>
  </sis-description-list>
</div>
